import * as yup from 'yup';

export const tipoMetricaSchema = yup.object({
  tipoMetricaId: yup.string().optional(),
  nombre: yup
    .string()
    .required('El nombre es obligatorio')
    .matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9.,¿?\s]+$/,
      'Solo se permiten letras, números, espacios, puntos, comas y signos de pregunta'
    )
    .test(
    'es-pregunta',
    'Debe ingresar una pregunta válida',
    (value) => {
      if (!value) return false;

      // Debe terminar en ?
      if (!/^¿?.*\?$/.test(value)) return false;

      // Debe contener al menos una letra o número
      return /[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]/.test(value);
    }
  ),
  estado: yup.boolean().required(),
});
